module.exports = __webpack_public_path__ + "img/s1-img6.43b71bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lifeHome/s1-img6.png
// module id = 406
// module chunks = 0